import OrderChangeQuantity from "../symbols/orderChangeQuantity";
import { HttpRequestPut } from "../../service";

const getOrderChangeQuantityAction = (payload: any) => ({
  type: OrderChangeQuantity.ORDER_CHANGE_QUANTITY,
  payload,
});
const getOrderChangeQuantitySuccessAction = (payload: any) => ({
  type: OrderChangeQuantity.ORDER_CHANGE_QUANTITY_SUCCESS,
  payload,
});
const getOrderChangeQuantityFailureAction = () => ({
  type: OrderChangeQuantity.ORDER_CHANGE_QUANTITY_FAILURE,
});
const clearOrderChangeQuantityAction = () => ({
  type: OrderChangeQuantity.CLEAR_ORDER_CHANGE_QUANTITY,
});

export function getOrderChangeQuantity(
  DeliveryId: string,
  OrderlineID: string,
  Quantity: string | number
) {
  return (dispatch: any) => {
    dispatch(getOrderChangeQuantityAction({}));

    HttpRequestPut(
      `/portal/delivery/${DeliveryId}/change-quantity/${OrderlineID}/${Quantity}`,
      dispatch,
      getOrderChangeQuantitySuccessAction,
      getOrderChangeQuantityFailureAction,
      true,
      {}
    );
  };
}

export function clearOrderChangeQuantity() {
  return (dispatch: any) => {
    dispatch(clearOrderChangeQuantityAction());
  };
}
